/** @format */
import { ProductBoxProps } from '@toucan/client/features/search/components/product-card/components/product-box/types';

import { ProductCardBreakpointsState } from './index';

/**
 * Gets width dependent product box props
 *
 * @param productCardBreakpointsState The state of the product card breakpoints
 * @returns { ProductBoxProps } Product box props
 */
export const getWidthDependentProductBoxProps = (
    productCardBreakpointsState: ProductCardBreakpointsState
) => {
    const productBoxProps: Pick<
        ProductBoxProps,
        'columns' | 'maxItemsPerColumn' | 'isCollapsable'
    > = {
        columns: productCardBreakpointsState?.large ? 2 : 1,
        maxItemsPerColumn: productCardBreakpointsState?.medium ? 5 : Infinity,
        isCollapsable: !productCardBreakpointsState?.medium,
    };

    return productBoxProps;
};
